import script from "./AddCreatorTagDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCreatorTagDialog.vue?vue&type=script&setup=true&lang=js"

import "./AddCreatorTagDialog.vue?vue&type=style&index=0&id=487292f7&lang=scss"

const __exports__ = script;

export default __exports__